/* RESPONSIBLE TEAM: team-standalone */
import BaseValidator from 'ember-cp-validations/validators/base';
import { inject as service } from '@ember/service';
import type Model from '@ember-data/model';
import type IntlService from 'ember-intl/services/intl';
import type { Block } from 'embercom/models/common/blocks/block';
import type { SyncHasMany } from '@ember-data/model';

export default class FallbackMessageBlocksNotEmpty extends BaseValidator {
  @service declare intl: IntlService;

  validate(
    value: unknown,
    options: ValidationOptions & { messageKey: string },
    model: Model & {
      sendFallbackMessageOnError: boolean;
      fallbackMessageOnErrorBlocks?: SyncHasMany<Block>;
    },
  ) {
    if (!model.sendFallbackMessageOnError) {
      return true;
    }

    if (value && (value as SyncHasMany<Block>).any((block: Block) => block.hasContent)) {
      return true;
    }

    return this.intl.t(options.messageKey);
  }

  static getDependentsFor() {
    return [
      'model.sendFallbackMessageOnError',
      'model.fallbackMessageOnErrorBlocks.@each.hasContent',
    ];
  }
}
